export default "/public/app-main/static/image/035d0f3f523b6f55b297ec81112334e6.png";